// styles.ts
import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

export const BlueSwitch = styled(Switch)(({ theme }) => ({
	'& .MuiSwitch-switchBase.Mui-checked': {
		color: '#2099B4',
		'&:hover': {
			backgroundColor: alpha('#2099B4', theme.palette.action.hoverOpacity),
		},
	},
	'& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
		backgroundColor: '#2099B4',
	},
}));

export const titleInputTextFieldSxStyles = (labelLength: number) => ({
	'& .MuiOutlinedInput-root': {
		backgroundColor: 'white',
		borderRadius: '30px',
		'& fieldset': {
			borderColor: '#d3d3d3',
		},
		'&:hover fieldset': {
			borderColor: '#d3d3d3',
		},
	},
	'& .MuiInputLabel-root.Mui-focused': {
		fontSize: '20px',
		fontFamily: 'Kan-Semibold',
		color: '#2099B4',
		left: `calc(100% - ${8.6 * labelLength + 46}px)`,
		transformOrigin: 'top right',
		marginTop: '0px',
	},
	// '& .MuiInputBase-input': {
	//   borderColor: '#d3d3d3',

	// },
	'& .MuiFilledInput-root::after': {
		borderBottomColor: '#2099B4',
	},
	'& .MuiFormLabel-root': {
		transformOrigin: 'top right',
		left: `calc(100% - ${8.6 * labelLength + 46}px)`,
		fontSize: '20px',
		marginTop: '-7px',
	},
	'& .MuiInputLabel-root': {
		color: '#d3d3d3',
	},
	'& .MuiInputBase-input': {
		padding: '9px',
		paddingRight: '18px',
		borderColor: '#d3d3d3',
	},
});

export const AutocompleteSxStyles = (d = 110) => ({
	width: 270,
	maxWidth: '100%', // #261: fit narrow screens
	height: '40px',
	'& .MuiOutlinedInput-root': {
		backgroundColor: 'white',
		borderRadius: '30px',
		'& fieldset': {
			borderColor: '#d3d3d3',
		},
		'&:hover fieldset': {
			border: 'none',
		},
	},
	'& .MuiInputLabel-root.Mui-focused': {
		fontSize: '20px',
		fontFamily: 'Kan-Semibold',
		color: '#2099B4',
		left: `calc(100% - ${d}px)`,
		transformOrigin: 'top right',
		marginTop: '0px',
	},
	'& .MuiFormLabel-root': {
		transformOrigin: 'top right',
		left: `calc(100% - ${d}px)`,
		fontSize: '20px',
		marginTop: '-9px',
	},
	'& .MuiInputLabel-root': {
		color: '#d3d3d3',
	},
	'& .MuiInputBase-input': {
		padding: '9px',
		paddingRight: '18px',
		color: 'black',
	},
	'& .MuiInputBase-root': {
		height: '40px',
	},
});

export const DatePickerSxStyles = () => ({
	'& .MuiOutlinedInput-root': {
		backgroundColor: 'white', // White background
		borderRadius: '30px', // Always rounded corners
		'& fieldset': {
			borderColor: '#d3d3d3', // Light gray border color
		},
		'&:hover fieldset': {
			border: 'none', // Keep light gray border on hover
		},
	},
	'& .MuiInputLabel-root.Mui-focused': {
		fontSize: '20px',
		fontFamily: 'Kan-Semibold',
		color: '#2099B4', // Label color on focus
		left: 'calc(100% - 170px)',
		transformOrigin: 'top right',
		marginTop: '-6px',
	},
	'& .MuiFilledInput-root::after': {
		borderBottomColor: '#2099B4', // Underline color on focus
	},
	'& .MuiFormLabel-root': {
		transformOrigin: 'top right',
		left: 'calc(100% - 170px)',
		fontSize: '20px',
		marginTop: '-10px',
	},
	// Styles for the label (floating label)
	'& .MuiInputLabel-root': {
		color: '#d3d3d3', // Light gray label color in normal state
	},
	'& .MuiInputBase-input': {
		padding: '9px',
		paddingRight: '18px',
		color: 'black',
	},
	'& .MuiInputLabel-shrink': {
		marginTop: '-6px',
	},
});

export const subtitleInputTextField2SxStyles = (d: number) => ({
	'& .MuiOutlinedInput-root': {
		padding: '0px',
		backgroundColor: 'transparent',
		bottomBorder: '1px solid #d3d3d3',
		'& fieldset': {
			border: 'none',
		},
		'&:hover fieldset': {
			border: 'none',
		},
	},
	'& .MuiInputLabel-root.Mui-focused': {
		fontSize: '16px',
		fontFamily: 'Kan-Semibold',
		color: '#2099B4',
		left: `calc(100% - ${d}px)`,
		transformOrigin: 'top right',
		marginTop: '0px',
	},
	'& .MuiFilledInput-root::after': {
		borderBottomColor: '#2099B4',
	},
	'& .MuiFormLabel-root': {
		transformOrigin: 'top right',
		left: `calc(100% - ${d}px)`,
		fontSize: '16px',
	},
	'& .MuiInputLabel-root': {
		color: '#a0a0a0',
		marginTop: '-10px',
	},
	'& .MuiInputLabel-shrink': {
		marginTop: '-1px',
	},
});
